import React, { useEffect, useState, useRef } from "react";
import DynamicTable from "../DynamicTable";

const SectionFive = (props) => {
    const {handleButtonClick ,setSelectedOptions ,selectedOptions,toggleOption ,setMessageBoard,setErrorTabEnable ,setmasterResetTab , data ,showMaximumChat} = props

    const [onClickYes, setOnClickYes] = useState(false);
    const [onClickNo, setOnClickNo] = useState(false);

    const isYesStepValid =data?.step_5_yes_next_steps ? (data?.step_5_yes_next_steps || '' ).toLowerCase() !== 'no' : false
    const isNoStepValid = data?.step_5_no_next_steps ? (data?.step_5_no_next_steps || '').toLowerCase() !== 'no': false

  //   useEffect(()=>{
  //     if (onClickNo && data?.step_5_no_text?.toLowerCase() === "nan") {
  //         props?.addMessages("Work Order", 10);
  //     }
  // }, [onClickNo, onClickYes])


  //   useEffect(()=>{

  //     if(onClickYes && data?.step_5_yes_call_logs){
  //         localStorage.setItem(
  //             "troubleShooting",
  //             JSON.stringify({ key1: data?.step_5_yes_call_logs })
  //           );
  //     }
  //     if(isNoStepValid && data?.step_5_no_call_logs ){
  //         localStorage.setItem(
  //             "troubleShooting",
  //             JSON.stringify({ key1: data?.step_5_no_call_logs })
  //           );
  //     }
  // })

  return (
    <>
    <div className="error-message-head1" style={{fontSize : showMaximumChat && '16px'}}>{data?.step_5_title}</div>
    <div className="error-message-head2" style={{fontSize : showMaximumChat && '16px'}} dangerouslySetInnerHTML={{ __html: data?.step_5_desc}}>
    </div>
    <div style={{ gap: "8px", display: "flex", marginTop: "22px" }}>
      <button
        onClick={() => {
    
          localStorage.setItem(
            "troubleShooting",
            JSON.stringify({ key1: data?.step_5_yes_call_logs })
          );
          handleButtonClick(5, "yes" ,{section : 'five',value:isYesStepValid});
          setOnClickYes(true);
          setOnClickNo(false);
            // Update selectedOptions based on `step_1_yes_text`
          if (isYesStepValid) {
            setSelectedOptions([true, true, true, true, true, true, false]);
          } else{
            setSelectedOptions([true, true, true, true, true, false, false]);
          }
        }}
        className={`option-button ${
          toggleOption[5] === "yes" ? "clicked" : ""
        }`}
        // disabled={selectedOptions[5]}
      >
        Yes
      </button>
      <button
        onClick={() => {
          localStorage.setItem(
            "troubleShooting",
            JSON.stringify({ key1: data?.step_5_no_call_logs })
          );
          handleButtonClick(5, "no",{section : 'five',value:isNoStepValid});
       
          
          setOnClickYes(false);
          setOnClickNo(true);
          if (isNoStepValid) {
            setSelectedOptions([true, true, true, true, true, true, false]);
          } else{
            setSelectedOptions([true, true, true, true, true, false, false]);
          }
        }}
        className={`option-button ${
          toggleOption[5] === "no" ? "clicked" : ""
        }`}
        // disabled={selectedOptions[5]}
      >
        No
      </button>
    </div>
    {onClickYes && <div className="error-message-head2" style={{fontSize : showMaximumChat && '16px'}} dangerouslySetInnerHTML={{ __html: data?.step_5_yes_text}}></div>}
    {onClickNo &&  data?.step_5_no_text?.toLowerCase() !== "nan" && <div className="error-message-head2" style={{fontSize : showMaximumChat && '16px'}} dangerouslySetInnerHTML={{ __html: data?.step_5_no_text}}></div>}

    {/* <div
      onClick={() => {
        setmasterResetTab(true);
        setErrorTabEnable(false);
      }}
      className="error-message-head2"
      style={{
        color: "#005FEC",
        textDecoration: "underline",
        pointerEvents: "cursor",
      }}
    >
      HDPVR Master Reset Procedure
    </div>
    <div className="error-message-head1">Call Logs</div> */}

    {/* //1 */}
    {/* <table
      style={{
        border: "1px",
        solid: "#ccc",
        borderCollapse: "collapse",
        width: "100%",
        marginTop: "12px",
      }}
    >
      <tr className="table-head">
        <td className="call-logs-table">
          <strong>Type</strong>
        </td>
        <td style={{ fontWeight: "400" }} className="call-logs-table">
          New Package
        </td>
      </tr>
      <tr className="table-head">
        <td className="call-logs-table">
          <strong>Area</strong>
        </td>
        <td style={{ fontWeight: "400" }} className="call-logs-table">
          Request
        </td>
      </tr>
      <tr className="table-head">
        <td className="call-logs-table">
          <strong>Sub Area</strong>
        </td>
        <td style={{ fontWeight: "400" }} className="call-logs-table">
          Modify Packages / Add Channel / Drop Channel / Scenario Specific
        </td>
      </tr>
      <tr className="table-head">
        <td className="call-logs-table">
          <strong>Resolution Code</strong>
        </td>
        <td style={{ fontWeight: "400" }} className="call-logs-table">
          Scenario Specific
        </td>
      </tr>
    </table> */}
    
    {onClickYes && data?.step_5_yes_call_logs && <DynamicTable data={data?.step_5_yes_call_logs} /> }
    {onClickNo && data?.step_5_no_call_logs && <DynamicTable data={data?.step_5_no_call_logs} /> }
  </>
  )
}

export default SectionFive
